import { useDebitAccountsQuery } from '../../react-query/hooks/query/accounts/use-debit-accounts';
import { useMyDebitCards, useRelatedDebitCards } from '../../react-query/hooks/query/use-debit-cards';

export const useOrderAvailableAccounts = () => {
    const { data: allAccounts } = useDebitAccountsQuery();
    const { data: myDebitCards } = useMyDebitCards();
    const { data: relatedDebitCards } = useRelatedDebitCards();

    const allDebitCardsAccountsNumbers = myDebitCards
        ?.concat(relatedDebitCards ?? [])
        .map((card) => card.accountNumber);

    return allAccounts?.filter((account) => !allDebitCardsAccountsNumbers?.includes(account.number));
};
